import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'

export const CountryMasterPopup = (props) => {
    return (
        <ModalBasic
            id="countryMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Country details</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-2'>
                        <label>Country name</label>
                        <TextInput type='text'
                            id='country' name='country'
                            value={props.countryObject.country}
                            handleChange={(event) => props.handleChange(event, 'country')}
                            className={props.validState?.error?.country !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.countryObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}